/// <reference path="../typings.d.ts" />
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, RouterOutlet, } from '@angular/router';
import { AppTitle, Breadcrumb } from './title';
import { Account, validateToken } from './account.service';
import { OneRosterService } from './oneroster.service';
import { Config } from './config';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { Alert } from './alert';
import { environment } from '../environments/environment';
import { AppService } from './app.service';
import { elapsedDaysHoursMinutes } from './elapsed';

@Component({
	selector: 'district-app',
	template: `
	<div id="page-wrapper" [class.open]="isSidebarToggled">
	  <div id="sidebar-wrapper" >
		<ul *ngIf="!showMenu()" class="sidebar">
		  <li class="sidebar-main">
			<a (click)="toggleSidebar()" style="cursor: pointer;">
				District One Roster
				<span class="menu-icon glyphicon glyphicon-transfer"></span>
			  </a>
		  </li>
		</ul>
		<ul *ngIf="showMenu()" class="sidebar">
		  <li class="sidebar-main">
			<a (click)="toggleSidebar()" style="cursor: pointer;">
				District One Roster
				<span class="menu-icon glyphicon glyphicon-transfer"></span>
			  </a>
		  </li>
		  <li class="sidebar-title"><span>NAVIGATION</span></li>
		  <li class="sidebar-list">
			<a [routerLink]="[registrationsLink]">Registrations</a>
		  </li>
		  <li class="sidebar-list">
			<a [routerLink]="[sftpLink]">SFTP</a>
		  </li>
		  <li class="sidebar-list">
				<a target="_blank" href="https://vm.success.centegix.com/article/189-oneroster-app">Support <span *ngIf="isSidebarToggled == null ? false : !isSidebarToggled" class="menu-icon glyphicon glyphicon-question-sign" title="Support"></span></a>
			</li>
		</ul>
		<div class="sidebar-footer">
		  <div class="col-xs-8">
			<a href="https://centegix.com" target="_blank" [title]="appVersionTitle">
			   &copy; {{today | date:'y'}} centegix.com
			  </a>
		  </div>
		</div>
	  </div>
	  <div id="content-wrapper">
		<div class="page-content">
		  <div class="row header">
			<div class="col-xs-12">
			  <div class="user pull-right" style="min-width:0px;padding:11px 15px 15px 15px;">
			  <a *ngIf="isUsrNull" style="cursor:pointer; color:#919191; vertical-align: middle;" (click)="logout()">Logout</a>
				<div class="dropdown" [class.open]="isUserToggled" style="text-align:right;">
				  <a style="cursor:pointer; color:#919191;" class="dropdown-toggle" data-toggle="dropdown" (click)="toggleUser()" [offClick]="clickedOutside">
						{{userGreeting}}
				    </a>
				  <ul class="dropdown-menu dropdown-menu-right" role="menu">
						<li class="link">
							<a [href]="accLink">
								Account
							</a>
						</li>
						<li class="divider"></li>
						<li class="link">
							<a (click)="logout()">
							    Logout
							</a>
						</li>
				  </ul>
				</div>
				<div *ngIf="showMenu()"><span>{{schoolsName}}</span></div>
			  </div>
			  <div class="meta">
				<div class="page">
				  {{dashboardTitle}}
				</div>
				<div class="breadcrumb-links">
					<span *ngFor="let b of breadcrumbs">/ <a *ngIf="!b.noLink" href="{{b.link}}">{{b.title}}</a> <span *ngIf="b.noLink">{{b.title}}</span> </span>
				</div>
			  </div>
			</div>
		  </div>
			<app-reload [maxIdle]="appReloadMaxIdle" [forceTimeout]="appReloadForceTimeout" (onChange)="appReload($event)"></app-reload>
			<div *ngIf="msg.msg" class="row">
				<div class="col-lg-5 col-md-7 col-xs-12">
					<alert [alert]="msg"></alert>
				</div>
			</div>
		  <router-outlet (activate)="changeRoute()"></router-outlet>
		  <district-footer></district-footer>
		</div>
	  </div>
	</div>
  `
})

export class AppComponent implements OnInit {
	isUserToggled: boolean;
	isSidebarToggled: boolean;
	today: number;
	acctNumber: string;
	msg: Alert;
	hasAccess: boolean;
	appReloadMaxIdle: number;
	appReloadForceTimeout: number;
	currentAppVersion: string;
	appVersionTitle: string;
	breadcrumbs: Breadcrumb[];
	userGreeting: string;
	dashboardTitle: string;
	accLink: string;
	schoolsName: string;
	interval: any;
	daysWarningAboutToExpire = 30;
	registrationsLink: string;
	sftpLink: string;
	isUsrNull: boolean;

	constructor(
		public title: AppTitle,
		private account: Account,
		private config: Config,
		private dvc: OneRosterService,
		private router: Router,
		angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
		private app: AppService,
		private cdref: ChangeDetectorRef,
	) {
		this.msg = new Alert();
		this.isUserToggled = false;
		this.isSidebarToggled = true;
		this.today = Date.now();
		this.clickedOutside = this.clickedOutside.bind(this);
		this.hasAccess = true;
		this.currentAppVersion = environment.version;
		this.appReloadMaxIdle = (60 * 5); // 5 min
		this.appReloadForceTimeout = (1000 * 60 * 60 * 12); // 12 hours
		this.appVersionTitle = `App Version: ${this.currentAppVersion}`;
		this.breadcrumbs = [];
		this.userGreeting = '';
		this.dashboardTitle = '';
		this.accLink = '';
		this.schoolsName = '';
		angulartics2GoogleAnalytics.startTracking();
		this.isUsrNull = false;
	}

	ngOnInit() {
		if (window.innerWidth < 992) {
			this.isSidebarToggled = false;
		}
		this.title.titleEvent.subscribe(() => {
			this.dashboardTitle = this.getDashboardTitle();
			this.breadcrumbs = this.getBreadcrumbs();
		});

		this.app.onLoadApp.subscribe((args) => {
			console.log('re-loading');
			this.load();
		});

		this.load();
	}

	load() {

		if (validateToken()) {
			// check existing user roles before loading default one
			let ur = this.dvc.userRoles();
			if (ur == null) {
				this.msg.error('There is an error when loading user\'s roles, please try refreshing this page.');
				this.isUsrNull = true;

				return;
			}
			this.acctNumber = ur.acctNumber;
			this.userGreeting = this.getUserGreetings();
			this.registrationsLink = `settings/${this.acctNumber}/registrations`;
			this.sftpLink = `settings/${this.acctNumber}/sftp`;

			// remove interval if any
			if (this.interval) {
				clearInterval(this.interval);
			}

			// validate token every 10 sec
			this.interval = setInterval(() => {
				if (!this.tokenValidation()) {
					clearInterval(this.interval);
					return;
				}
			}, 10000);

		}
	}

	changeRoute() {
		this.schoolsName = this.schoolName();
		this.accLink = this.accountLink();
	}

	tokenValidation(): boolean {
		let t = this.dvc.getToken();
		// no need to display user message about token expiration in case of refreshToken being present
		if (t.refreshToken && t.refreshToken != '') {
			return true;
		}
		if (!validateToken()) {
			var c = 10;
			// current url is passed to login component for auth.ts to catch and send within redirect_uri for returning the user to the current page after login
			var url = encodeURIComponent(this.router.url);
			var interval = setInterval(() => {
				this.msg.warningHtml(`This session has expired, please wait while redirecting you to <a href="#/login?gotopage=${url}">login page</a> in ${c}.`);
				c--;
				if (c < 0) {
					clearInterval(interval);
					this.router.navigate(['/login', { queryParams: { 'gotopage': url } }])
				}
			}, 1000);
			return false;
		}
		return true
	}

	clickedOutside() {
		this.isUserToggled = false;
	}

	toggleSidebar() {
		this.isSidebarToggled = !this.isSidebarToggled;
	}

	toggleUser() {
		this.isUserToggled = !this.isUserToggled;
	}


	getDashboardTitle() {
		return this.title.getDashboardTitle();
	}

	getDashboardNav() {
		return this.title.getDashboardNav();
	}

	getBreadcrumbs() {
		return this.title.getBreadcrumbsPrint();
	}

	accountLink() {
		return this.config.authAppUrl + '/dashboard/profile'
	}

	logout() {
		this.account.removeLocalStorage();
		this.dvc.removeLocalStorage();
		this.account.logout();
	}

	schoolName() {
		let s = this.dvc.userRoles();
		if (s != null) {
			return s.schoolName;
		}
		return 'NA';
	}

	showMenu() {
		if (this.account.getUser() != null && this.dvc.userRoles() != null) {
			this.acctNumber = this.dvc.userRoles().acctNumber;
			return true;
		}
		return true;
	}

	appReload(version: string) {
		if (this.currentAppVersion != version) {
			console.log('version:', version);
			window.location.reload(true);
		}
	}

	ngAfterContentChecked() {
		this.cdref.detectChanges();
	}

	getUserGreetings() {
		let user = this.account.getUser();
		if (user == null) {
			return "Hi";
		}
		return 'Hi ' + user.firstName;
	}
}
